module.exports = __webpack_public_path__ + "static/media/Tympole_gaussian2.f1249804.png";